// Vendors
import React from 'react';

const MainNotice = ({ mainNotice }) => (
  <div className="grid__col-xs-12">
    <div
      className={`notice notice--${mainNotice.type}`}
      role="alert"
      style={{ maxWidth: '600px' }}
      dangerouslySetInnerHTML={{ __html: mainNotice.message }}
    />
  </div>
);

export default MainNotice;
